module.exports = __webpack_public_path__ + "static/media/cert1.72b9879d.png";